import React, { useEffect, useReducer, useState } from 'react';
import LoadingBox from '../components/LoadingBox';
//import { Store } from '../Store';
import { useNavigate, useParams } from 'react-router-dom';
import api, { API_BASE_URL } from '../api';
import { Helmet } from 'react-helmet-async';
import { Button, Card, Col, ListGroup, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { getError } from '../Util';
import MessageBox from '../components/MeaasgeBox';
import Container from 'react-bootstrap/Container';
import CardHeader from '../components/CardHeadder';
import jsPDF from 'jspdf';
import toplogo from '../assets/top_logo.png';
import CheckoutSteps from '../components/CheckoutSteps';

function reducer(state, action) {
  switch (action.type) {
    case 'FETCH_REQUEST':
      return { ...state, loading: true, error: '' };
    case 'FETCH_SUCCESS':
      return { ...state, loading: false, order: action.payload, error: '' };
    case 'FETCH_FAIL':
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
}

export default function OrderScreen() {
  const params = useParams();
  const { id: orderId } = params;
  const navigate = useNavigate();

  const [{ loading, error, order }, dispatch] = useReducer(reducer, {
    loading: true,
    order: {},
    error: '',
  });

  const [siteSettings, setSiteSettings] = useState(null);

  useEffect(() => {
    const fetchOrder = async () => {
      try {
        dispatch({ type: 'FETCH_REQUEST' });
        const { data } = await api.get(`/api/orders/${orderId}`);
        dispatch({ type: 'FETCH_SUCCESS', payload: data });
      } catch (err) {
        dispatch({ type: 'FETCH_FAIL', payload: getError(err) });
      }
    };

    const fetchSettings = async () => {
      try {
        const { data } = await api.get('/api/settings');
        setSiteSettings(data);
      } catch (err) {
        console.error('Failed to fetch site settings:', err);
      }
    };

    fetchOrder();
    fetchSettings();
  }, [orderId]);

  const downloadPDFHandler = () => {
    const doc = new jsPDF();
    let yPos = 15;
    const pageWidth = doc.internal.pageSize.width;
    const margin = 15;

    // Header with Logo - circular shape (equal width and height)
    doc.addImage(toplogo, 'PNG', margin, yPos, 20, 20);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(22);
    doc.setTextColor(128, 16, 1); // customRed (#801001)
    doc.text(siteSettings?.site_name || 'Kobithan Garments', margin + 25, yPos + 10);
    
    doc.setFontSize(10);
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(0);
    const companyAddress = doc.splitTextToSize(
      `${siteSettings?.address || 'No.14, Eight Acre, Viyasar Road, Thonikkal, Vavuniya, Sri Lanka. 43000'}\n` +
        `Tel: +${siteSettings?.phone || siteSettings?.whatsapp_number || '94703533536'}\n` +
        `Email: ${siteSettings?.email || 'info@kobithangarments.com'}`,
      120
    );
    doc.text(companyAddress, margin + 25, yPos + 18);

    yPos += 40;

    doc.setFontSize(16);
    doc.setFont('helvetica', 'bold');
    doc.text(`Order Summary - #${order.orderCode || orderId}`, margin, yPos);
    doc.setFontSize(10);
    doc.text(
      `Date: ${new Date(order.createdAt).toLocaleDateString()}`,
      pageWidth - margin,
      yPos,
      { align: 'right' }
    );
    yPos += 12;

    doc.setDrawColor(200);
    doc.line(margin, yPos, pageWidth - margin, yPos);
    yPos += 10;

    // Customer Details
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(12);
    doc.text('Customer Details:', margin, yPos);
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(10);
    doc.text(
      `${order.shippingAddress.fullName}\n` +
        `WhatsApp: ${order.shippingAddress.whatsapp}\n` +
        `${order.shippingAddress.address}\n` +
        `${order.shippingAddress.city}`,
      margin,
      yPos + 8
    );

    const orderX = pageWidth - margin - 60;
    doc.setFont('helvetica', 'bold');
    doc.text('Order Details:', orderX, yPos);
    doc.setFont('helvetica', 'normal');
    doc.text(`Order ID: ${order.orderCode || orderId}`, orderX, yPos + 6);
    yPos += 35;

    // Table Header - without Price and Total columns
    const hasColor = order.orderItems.some(item => item.selectedColor || item.color);
    
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(11);
    doc.text('#', margin, yPos);
    doc.text('Description', margin + 10, yPos);
    doc.text('Size', margin + 90, yPos);
    if (hasColor) {
      doc.text('Color', margin + 115, yPos);
    }
    doc.text('Qty', hasColor ? margin + 145 : margin + 120, yPos);
    yPos += 6;
    doc.setDrawColor(0);
    doc.line(margin, yPos, pageWidth - margin, yPos);
    yPos += 8;

    // Table Body - without Price and Total
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(10);
    order.orderItems.forEach((item, index) => {
      doc.text(`${index + 1}.`, margin, yPos);
      doc.text(`${item.name} (${item.code})`, margin + 10, yPos, { maxWidth: 75 });
      doc.text(item.selectedSize || item.size || 'N/A', margin + 90, yPos);
      if (hasColor) {
        doc.text(item.selectedColor || item.color || '-', margin + 115, yPos);
      }
      doc.text(`${item.quantity}`, hasColor ? margin + 145 : margin + 120, yPos);
      yPos += 10;
    });

    yPos += 5;
    doc.line(margin, yPos, pageWidth - margin, yPos);

    doc.setFontSize(9);
    doc.setFont('helvetica', 'italic');
    doc.setTextColor(100);
    const footerY = doc.internal.pageSize.height - 15;
    doc.text('Thank you for your order!', margin, footerY);
    doc.text(
      'Terms: Goods sold are not returnable',
      pageWidth - margin,
      footerY,
      { align: 'right' }
    );

    doc.save(`order_${order.orderCode || orderId}.pdf`);
  };

  return loading ? (
    <LoadingBox></LoadingBox>
  ) : error ? (
    <MessageBox variant="danger">{error}</MessageBox>
  ) : (
    <div>
      <CardHeader />
      <Container fluid="md" className="mt-5 py-5">
        <div className="marginAll">
          <Helmet>
            <title>Order {orderId}</title>
          </Helmet>
          <CheckoutSteps step1 step2 step3 step4></CheckoutSteps>
          <h1 style={{ fontSize: '2rem' }}>Order ID - {orderId}</h1>
          <br />

          <Row>
            <Col>
              <Row>
                <Col md={6} className="d-flex">
                  <Card className="mb-3 mt-5 bg-light text-dark w-100 h-90">
                    <Card.Body>
                      <Card.Title style={{ color: '#801001' }}>
                        Shipping Details
                      </Card.Title>
                      <Card.Text>
                        <strong>Name:</strong> {order.shippingAddress.fullName}
                        <br />
                        <strong>Address:</strong>{' '}
                        {order.shippingAddress.address},{' '}
                        {order.shippingAddress.city},{' '}
                        {order.shippingAddress.postalCode},{' '}
                        {order.shippingAddress.country}
                        <br />
                        <strong>WhatsApp:</strong>{' '}
                        {order.shippingAddress.whatsapp}
                        <br />
                      </Card.Text>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>

              <Card className="mb-3 bg-light text-dark">
                <Card.Body>
                  <Card.Title style={{ color: '#801001' }}>Items</Card.Title>
                  <ListGroup variant="flush">
                    {order.orderItems.map((item) => (
                      <ListGroup.Item key={item._id}>
                        <Row className="align-items-center">
                          <Col
                            md={5}
                            className="d-flex align-items-center gap-3"
                          >
                            <img
                              src={item.image ? (item.image.startsWith('http') ? item.image : `${API_BASE_URL}/storage/${item.image}`) : ''}
                              alt={item.name}
                              className="img-fluid rounded img-thumbnail"
                              style={{
                                width: '100px',
                                height: '100px',
                                objectFit: 'cover',
                              }}
                            />
                            <Link
                              className="cardname"
                              to={`/product/${item.slug}`}
                            >
                              <strong style={{ color: '#801001' }}>
                                {item.name}
                              </strong>
                            </Link>
                          </Col>

                          <Col
                            md={7}
                            className="d-flex align-items-center justify-content-between flex-wrap gap-2"
                          >
                            <strong style={{ color: '#801001' }}>
                              ID: {item.code}
                            </strong>
                            {item.selectedSize && (
                              <strong style={{ color: '#801001' }}>
                                Size: {item.selectedSize}
                              </strong>
                            )}
                            {(item.selectedColor || item.color) && (
                              <strong style={{ color: '#801001' }}>
                                Color: {item.selectedColor || item.color}
                              </strong>
                            )}
                            <strong style={{ color: '#801001' }}>
                              <span>Qty: {item.quantity}</span>
                            </strong>
                            
                          </Col>
                        </Row>
                      </ListGroup.Item>
                    ))}
                  </ListGroup>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          <div className="d-flex justify-content-end mt-4 gap-3">
            <Button
              type="button"
              className="btn btn-secondary"
              onClick={downloadPDFHandler}
              style={{ backgroundColor: '#801001', border: 'none' }}
            >
              <i className="fas fa-file-pdf me-2"></i> Download PDF
            </Button>
            <Button
              type="button"
              className="btn btn-primary"
              onClick={() => navigate('/products')}
            >
              Continue Shopping
            </Button>
          </div>
        </div>
      </Container>
    </div>
  );
}
